import React from 'react';
import classNames from 'classnames';

const Navigation = ({ onNavSelect, onNavClose, activeNav, menuToggle, screenSize }) => {

  const handleNavSelect = (e) => {
    onNavSelect(e);
    onNavClose()
  }

  return (
    <nav className={classNames('mdw__main-header--nav', { 'open': menuToggle })}>
      <div 
      className="nav-items"
      onClick={(e) => handleNavSelect(e)}
      >
        <button className={classNames('nav-links',{
          'activeLink': activeNav === 'landing'
        })} data-section="landing">Home</button>
      </div>
      <div className="nav-items"
      onClick={(e) => handleNavSelect(e)}
      >
        <button className={classNames('nav-links',{
          'activeLink': activeNav === 'features'
        })} data-section="features">Features</button>
      </div>
      <div className="nav-items"
      onClick={(e) => handleNavSelect(e)}
      >
        <button className={classNames('nav-links',{
          'activeLink': activeNav === 'madverse'
        })} data-section="madverse">Madverse</button>
      </div>
      <div className="nav-items"
      onClick={(e) => handleNavSelect(e)}
      >
        <button className={classNames('nav-links',{
          'activeLink': activeNav === 'newsletter'
        })} data-section="newsletter">News</button>
      </div>
      <div className="nav-items"
      onClick={(e) => handleNavSelect(e)}
      >
        <button className={classNames('nav-links',{
          'activeLink': activeNav === 'community'
        })} data-section="community">Community</button>
      </div>
      { (screenSize === 'mobile') ?
          (<div className="nav-items">
            <span className="nav-links lang">En</span>
            </div>) : null
      }
    </nav>
  )
}

export default Navigation;
